import React from 'react';
import { Container, Paper, Stack, Typography, Button } from '@mui/material';

/**
 * Without this, one bad render blanks the entire tab — which is how the app
 * behaved when OtpVerify hit a malformed query param. A clinician mid-assessment
 * deserves a way back rather than a white screen.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // No error-reporting service is wired up yet; the console is the fallback.
    console.error('Unhandled UI error:', error, info);
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <Container maxWidth="sm" sx={{ py: 8 }}>
        <Paper sx={{ p: 4 }}>
          <Stack spacing={2} alignItems="flex-start">
            <Typography variant="h2">Something went wrong</Typography>
            <Typography variant="body2" color="text.secondary">
              This screen failed to load. Your saved work is unaffected — reloading usually clears it.
            </Typography>
            <Stack direction="row" spacing={1}>
              <Button variant="contained" onClick={() => window.location.reload()}>Reload</Button>
              <Button onClick={() => { window.location.href = '/'; }}>Go home</Button>
            </Stack>
          </Stack>
        </Paper>
      </Container>
    );
  }
}

export default ErrorBoundary;
